import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import TrademarkOverview from '../components/TrademarkOverview';
import ServicesSection from '../components/ServicesSection';
import WhyChooseUs from '../components/WhyChooseUs';
import ProcessSection from '../components/ProcessSection';
import PricingSection from '../components/PricingSection';
import IndustriesSection from '../components/IndustriesSection';
import BenefitsSection from '../components/BenefitsSection';
import TrustSignals from '../components/TrustSignals';
import TestimonialsSection from '../components/TestimonialsSection';
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';
import ContactSection from '../components/ContactSection';

const Home = ({ openPopup }) => {
  return (
    <>
      <Helmet>
        <title>Trademark Registration Services - Expert USPTO Filing | Trademark Texticon</title>
        <meta name="description" content="Professional trademark registration services with 98% USPTO approval rate. Protect your brand with expert trademark search, filing, and monitoring. Affordable packages starting at $45. Serving all 50 states." />
        <meta name="keywords" content="trademark registration, USPTO filing, trademark search, brand protection, trademark attorney, trademark application, federal trademark, trademark monitoring, intellectual property" />
        <meta property="og:title" content="Trademark Registration Services - Expert USPTO Filing | Trademark Texticon" />
        <meta property="og:description" content="Professional trademark registration with 98% success rate. 1000+ trademarks registered. Expert legal team. Packages from $45." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Trademark Registration Services - Expert USPTO Filing" />
        <meta name="twitter:description" content="Protect your brand with professional trademark registration. 98% success rate, 15+ years experience." />
      </Helmet>
      
      <div className="home-page">
        <HeroSection openPopup={openPopup} />
        <AboutSection />
        <TrademarkOverview openPopup={openPopup} />
        <ServicesSection openPopup={openPopup} />
        <WhyChooseUs />
        <ProcessSection openPopup={openPopup} />
        <PricingSection openPopup={openPopup} />
        <IndustriesSection />
        <BenefitsSection />
        <TrustSignals />
        <TestimonialsSection />
        <FAQSection />
        <CTASection openPopup={openPopup} />
        <ContactSection />
      </div>
    </>
  );
};

export default Home;
